module.exports = __webpack_public_path__ + "img/Relogio.79e317bc.svg";